var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { State, Action, Selector } from '@ngxs/store';
import { ViewActions } from './view.actions';
import { LayoutDefault, LogoLayout, DrawerLayout } from '../models/view-layout.model';
import { Fullscreen } from 'src/app/shared/libraries/fullscreen/fullscreen';
import { TreeSearchDisplayMode } from 'src/app/shared/components/tree/tree-search/tree-search.component';
import { ViewLayoutStatus } from '../models/view-layout-status.enum';
import { LoaderTypeEnum } from '../models/loader-type.enum';
var ViewStateModel = /** @class */ (function () {
    function ViewStateModel() {
    }
    return ViewStateModel;
}());
export { ViewStateModel };
export var initialLayout = {
    audio: new LayoutDefault(),
    camera: new LayoutDefault(ViewLayoutStatus.Show, true),
    chapterList: new LayoutDefault(ViewLayoutStatus.Show, false),
    column: new LayoutDefault(),
    description: new LayoutDefault(),
    drawer: new DrawerLayout(),
    fullscreen: new LayoutDefault(),
    help: new LayoutDefault(),
    labelInfo: new LayoutDefault(),
    labelList: new LayoutDefault(ViewLayoutStatus.Show, false),
    logo: new LogoLayout(),
    media: new LayoutDefault(),
    menu: new LayoutDefault(),
    nodeInfo: new LayoutDefault(ViewLayoutStatus.Hide, false),
    pagination: new LayoutDefault(),
    presenter: new LayoutDefault(ViewLayoutStatus.Hide, false),
    reset: new LayoutDefault(),
    search: new LayoutDefault(),
    toolbar: new LayoutDefault(),
    tools: new LayoutDefault(),
};
export var initialViewState = {
    breakpoint: null,
    labelsBreakpoint: 480,
    inputEnabled: true,
    fullscreenActive: false,
    presentationActive: false,
    drawerCoversContent: false,
    searchDisplayMode: TreeSearchDisplayMode.List,
    showNodeInfo: false,
    showHelp: false,
    loaderActive: false,
    loaderType: LoaderTypeEnum.Play,
    usePrintImage: false,
    multiPickModeEnabled: false,
    canHover: false,
    canTouch: false,
    canFullscreen: false,
    layout: initialLayout,
    initialLayout: initialLayout
};
var ViewState = /** @class */ (function () {
    function ViewState() {
    }
    // ---------- Selectors ----------
    ViewState.getLayout = function (state) {
        return state.layout;
    };
    ViewState.getInitialLayout = function (state) {
        return state.initialLayout;
    };
    ViewState.getBreakpoint = function (state) {
        return state.breakpoint;
    };
    ViewState.getLabelsBreakpoint = function (state) {
        return state.labelsBreakpoint;
    };
    ViewState.getInputEnabled = function (state) {
        return state.inputEnabled;
    };
    ViewState.getFullscreenActive = function (state) {
        return state.fullscreenActive;
    };
    ViewState.getPresentationActive = function (state) {
        return state.presentationActive;
    };
    ViewState.getDrawerCoversContent = function (state) {
        return state.drawerCoversContent;
    };
    ViewState.getShowNodeInfo = function (state) {
        return state.showNodeInfo;
    };
    ViewState.getShowHelp = function (state) {
        return state.showHelp;
    };
    ViewState.getLoaderActive = function (state) {
        return state.loaderActive;
    };
    ViewState.getLoaderType = function (state) {
        return state.loaderType;
    };
    ViewState.getCanTouch = function (state) {
        return state.canTouch;
    };
    ViewState.getCanHover = function (state) {
        return state.canHover;
    };
    ViewState.getMultiPickModeEnabled = function (state) {
        return state.multiPickModeEnabled;
    };
    ViewState.getSearchDisplayMode = function (state) {
        return state.searchDisplayMode;
    };
    ViewState.getUsePrintImage = function (state) {
        return state.usePrintImage;
    };
    // ---------- Actions ----------
    ViewState.prototype.setLayout = function (context, action) {
        var layout = context.getState().layout;
        context.patchState({
            layout: __assign({}, layout, action.layout)
        });
    };
    ViewState.prototype.setInitialLayout = function (context, _a) {
        var layout = _a.layout;
        context.patchState({
            initialLayout: layout
        });
    };
    ViewState.prototype.setBreakpoint = function (context, action) {
        context.patchState({
            breakpoint: action.breakpoint
        });
    };
    ViewState.prototype.setInputEnabled = function (context, action) {
        context.patchState({
            inputEnabled: action.enabled
        });
    };
    ViewState.prototype.setCanHover = function (context, action) {
        context.patchState({
            canHover: action.canHover
        });
    };
    ViewState.prototype.setCanTouch = function (context, action) {
        context.patchState({
            canTouch: action.canTouch
        });
    };
    ViewState.prototype.setCanFullscreen = function (context, action) {
        context.patchState({
            canFullscreen: action.canFullscreen
        });
    };
    ViewState.prototype.setSearchDisplayMode = function (context, action) {
        context.patchState({
            searchDisplayMode: action.mode
        });
    };
    ViewState.prototype.toggleNodeInfo = function (context, action) {
        context.patchState({
            showNodeInfo: action.show
        });
    };
    ViewState.prototype.togglePresentation = function (context, action) {
        context.patchState({
            presentationActive: action.active
        });
    };
    ViewState.prototype.toggleHelp = function (context, action) {
        context.patchState({
            showHelp: action.show
        });
    };
    ViewState.prototype.toggleLoader = function (context, action) {
        context.patchState({
            loaderActive: action.show
        });
    };
    ViewState.prototype.setLoaderType = function (context, action) {
        context.patchState({
            loaderType: action.loaderType
        });
    };
    ViewState.prototype.setMultiPickModeEnabled = function (context, action) {
        context.patchState({
            multiPickModeEnabled: action.enabled
        });
    };
    ViewState.prototype.setLabelBreakpoint = function (context, action) {
        context.patchState({
            labelsBreakpoint: action.labelsBreakpoint
        });
    };
    ViewState.prototype.setUsePrintImage = function (context, action) {
        context.patchState({
            usePrintImage: action.usePrintImage
        });
    };
    ViewState.prototype.ngxsOnInit = function (context) {
        var fullscreen$ = Fullscreen.onFullscreenChange();
        fullscreen$.subscribe(function (event) {
            context.patchState({
                fullscreenActive: Fullscreen.isFullscreen()
            });
        });
    };
    __decorate([
        Action(ViewActions.SetLayout),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetLayout]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setLayout", null);
    __decorate([
        Action(ViewActions.SetInitialLayout),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetInitialLayout]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setInitialLayout", null);
    __decorate([
        Action(ViewActions.SetBreakpoint),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetBreakpoint]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setBreakpoint", null);
    __decorate([
        Action(ViewActions.SetInputEnabled),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetInputEnabled]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setInputEnabled", null);
    __decorate([
        Action(ViewActions.SetCanHover),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetCanHover]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setCanHover", null);
    __decorate([
        Action(ViewActions.SetCanTouch),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetCanTouch]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setCanTouch", null);
    __decorate([
        Action(ViewActions.SetCanFullscreen),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetCanFullscreen]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setCanFullscreen", null);
    __decorate([
        Action(ViewActions.SetSearchDisplayMode),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetSearchDisplayMode]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setSearchDisplayMode", null);
    __decorate([
        Action(ViewActions.ToggleNodeInfo),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.ToggleNodeInfo]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "toggleNodeInfo", null);
    __decorate([
        Action(ViewActions.TogglePresentation),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.TogglePresentation]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "togglePresentation", null);
    __decorate([
        Action(ViewActions.ToggleHelp),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.ToggleHelp]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "toggleHelp", null);
    __decorate([
        Action(ViewActions.ToggleLoader),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.ToggleLoader]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "toggleLoader", null);
    __decorate([
        Action(ViewActions.SetLoaderType),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetLoaderType]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setLoaderType", null);
    __decorate([
        Action(ViewActions.SetMultiPickModeEnabled),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetMultiPickModeEnabled]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setMultiPickModeEnabled", null);
    __decorate([
        Action(ViewActions.SetLabelBreakpoint),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetLabelBreakpoint]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setLabelBreakpoint", null);
    __decorate([
        Action(ViewActions.SetUsePrintImage),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ViewActions.SetUsePrintImage]),
        __metadata("design:returntype", void 0)
    ], ViewState.prototype, "setUsePrintImage", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getLayout", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getInitialLayout", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getBreakpoint", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getLabelsBreakpoint", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getInputEnabled", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getFullscreenActive", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getPresentationActive", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getDrawerCoversContent", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getShowNodeInfo", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getShowHelp", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getLoaderActive", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getLoaderType", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getCanTouch", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getCanHover", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getMultiPickModeEnabled", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getSearchDisplayMode", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [ViewStateModel]),
        __metadata("design:returntype", void 0)
    ], ViewState, "getUsePrintImage", null);
    ViewState = __decorate([
        State({
            name: 'view',
            defaults: initialViewState
        })
    ], ViewState);
    return ViewState;
}());
export { ViewState };
